import { Card, Flex, Form, Segmented, Table, TableProps } from 'antd';
import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

// components
import ActionListHeaderComponent from 'modules/main/actions/listHeader';

// services

// styles

// models
import { ServiceCost } from '../../commonModels';
import { onGetServiceCost } from '../../commonServices';
import SystemSuspendListComponent from '../components/systemSuspednList';
import CompanySuspendListComponent from '../components/companySuspednList';

interface SuspendListPageProps {}

const SuspendListPage: FunctionComponent<SuspendListPageProps> = () => {
	const { t } = useTranslation();

	const [suspendView, setSuspendView] = useState<'company' | 'system'>('company');
	const [generalSuspend, setGeneralSuspend] = useState<boolean>(false);

	const [serviceCostLoading, setServiceCostLoading] = useState<boolean>(true);
	const [serviceCost, setServiceCost] = useState<ServiceCost>();

	useEffect(() => {
		getServiceCost();
	}, []);

	const getServiceCost = async () => {
		try {
			setServiceCostLoading(true);

			const response = await onGetServiceCost('general_suspend');
			setServiceCost(response?.success);

			setServiceCostLoading(false);
		} catch (error) {
			setServiceCostLoading(false);
		}
	};

	return (
		<>
			<ActionListHeaderComponent
				title={t('ACTIONS.SUSPEND')}
				subTitle={t('ACTIONS.SUSPEND_COMPANY_SHARES')}
				costLoading={serviceCostLoading}
				costs={[serviceCost!]}
				addAvailable={suspendView === 'company' && !generalSuspend}
				addAvailableText={suspendView === 'company' && generalSuspend ? t('ACTIONS.ALL_SHARES_SUSPENDED') : undefined}
			/>

			<Segmented
				block
				className="custom mb-5"
				size="middle"
				onChange={(value: 'company' | 'system') => setSuspendView(value)}
				options={[
					{ value: 'company', label: t('ACTIONS.COMPANY_SUSPEND') },
					{ value: 'system', label: t('ACTIONS.SYSTEM_SUSPEND') },
				]}
			/>

			{suspendView === 'company' ? (
				<CompanySuspendListComponent generalSuspendChanged={setGeneralSuspend} />
			) : (
				<SystemSuspendListComponent />
			)}
		</>
	);
};

export default SuspendListPage;
